module.exports = __webpack_public_path__ + "static/media/ic_esign_done_fisdom.af1c1d9c.svg";